import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

export class PasswordValidator {
	static areEqual(formGroup: UntypedFormGroup) {
		let val;
		let valid = true;

		for (const key in formGroup.controls) {
			if (formGroup.controls.hasOwnProperty(key)) {
				const control: UntypedFormControl = <UntypedFormControl>formGroup.controls[key];

				if (val === undefined) {
					val = control.value;
				} else {
					if (val !== control.value) {
						valid = false;
						break;
					}
				}
			}
		}

		if (valid) {
			return null;
		}

		return {
			areEqual: true,
		};
	}
}
